/**
 * Hook used to determine whether a user is viewing GiveWise via
 * the mobile app.
 * Note: The user agent value of "GiveWiseMobile/1.0" is set in the mobile app
 * wrapper (e.g. in WebView configuration), not here in the webapp.
 */
export function useUserIsOnMobileApp() {
  const userIsOnMobileApp = navigator.userAgent.includes('GiveWiseMobile')
  return userIsOnMobileApp
}
